import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export const SESSION_COOKIE_NAME = 'dv_access_token';

export const REFRESH_COOKIE_NAME = 'dv_refresh_token';

export const ID_TOKEN_COOKIE_NAME = 'dv_id_token';

const REFRESH_TOKEN_TTL_SECONDS = 60 * 60;

@Injectable({ providedIn: 'root' })
export class SessionCookieService {
  public read(): string | null {
    return this.get(SESSION_COOKIE_NAME);
  }

  public readRefreshToken(): string | null {
    return this.get(REFRESH_COOKIE_NAME);
  }

  public readIdToken(): string | null {
    return this.get(ID_TOKEN_COOKIE_NAME);
  }

  public writeIdToken(token: string): void {
    this.set(ID_TOKEN_COOKIE_NAME, token, REFRESH_TOKEN_TTL_SECONDS);
  }

  public write(token: string, expiresInSeconds: number): void {
    this.set(SESSION_COOKIE_NAME, token, expiresInSeconds);
  }

  public writeRefreshToken(token: string): void {
    this.set(REFRESH_COOKIE_NAME, token, REFRESH_TOKEN_TTL_SECONDS);
  }

  public clear(): void {
    const domain = environment.sessionCookieDomain;
    if (!domain) {
      return;
    }

    for (const name of [
      SESSION_COOKIE_NAME,
      REFRESH_COOKIE_NAME,
      ID_TOKEN_COOKIE_NAME,
    ]) {
      document.cookie = `${name}=; Domain=${domain}; Path=/; Max-Age=0; SameSite=Lax; Secure`;
    }
  }

  private get(name: string): string | null {
    if (!environment.sessionCookieDomain) {
      return null;
    }

    const match = document.cookie
      .split('; ')
      .find(entry => entry.startsWith(`${name}=`));
    const value = match?.slice(name.length + 1) ?? '';
    return value || null;
  }

  private set(name: string, value: string, expiresInSeconds: number): void {
    const domain = environment.sessionCookieDomain;
    if (!domain) {
      return;
    }

    document.cookie = [
      `${name}=${value}`,
      `Domain=${domain}`,
      'Path=/',
      `Max-Age=${expiresInSeconds}`,
      'SameSite=Lax',
      'Secure',
    ].join('; ');
  }
}
